import { render, staticRenderFns } from "./SignUpOptions.vue?vue&type=template&id=225a4b48"
import script from "./SignUpOptions.vue?vue&type=script&lang=ts"
export * from "./SignUpOptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports